import { createApp, reactive, ref, watch, watchEffect, computed } from 'vue';
import googleAnalytics from "../GoogleAnalytics.js";
import { useLoading } from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';

window.initalizeQuickpay = (initData) => {

    const app = {
        setup() {
            const state = reactive({
                authenticationModel: initData,
                makePaymentModel: null,
                confirmationModel: null,
                reviewModel: null,
                selectedBiller: {},
                acceptedLegalAgreement: false,
                acceptedLegalAgreementError: null,
                disableSubmitButtons: false,
                showPaymentServicesiframe: true,
                supportNumber: "1-800-473-6879",
                initSections: "init",
                paymentAmountSelected: "",
                paymentAmount: 0,
                customPaymentAmount: null,
                customAmountSelected: false,
                emailAddress: "",
                requestAccessActiveSection: "init",
                showFullAgreement: false,
                accountOrPolicyHelp: false,
                invoiceHelp: false,
                activeSection: initData.authorizationSection,
                authentication: initData.authorizationSection,
                makePayment: initData.makePaymentSection,
                review: initData.confirmationSection,
                complete: initData.completeSection,
                selectBiller: initData.selectionSection,
                displayLoadingImage: false,
                displayLoadingImageBackdrop: false,
                modal: { title: "Error", message: "", confirmText: "Continue", classes: "" },
                displayModal: false,
                accountOrPolicyHelpSection: "",
                paylinkCompleteModel: null,
                confirmationModel: {},
                authenticationForm: {
                    accountOrPolicyNumberError: null,
                    zipCodeError: null,
                    formSubmitted: false,
                },
                paymentOptionsForm: {
                    paymentAmount: "",
                    emailAddress: "",
                    emailAddressError: null,
                    confirmEmailAddress: "",
                    confirmEmailAddressError: null,
                    formSubmitted: false,
                },
                connectAccessRequest: {
                    firstName: "",
                    firstNameError: null,
                    lastName: "",
                    lastNameError: "",
                    emailAddress: "",
                    emailAddressError: "",
                    confirmEmailAddress: "",
                    emailsMatch: false,
                    formSubmitted: false,
                },
                reviewOptionsForm: {
                    agree: false,
                    formSubmitted: false
                }
            });

            const getIsRequiredError = (value, fieldDisplayText) => {
                if (!value) {
                    return fieldDisplayText + " is required";
                }
                return null;
            }

            const getPaymentAmountError = () => {
                const selectedPaymentAmount = parseFloat(getSelectedPaymentAmount()).toFixed(2);

                const isRequiredError = getIsRequiredError(selectedPaymentAmount, "Payment amount");
                if (isRequiredError !== null) {
                    return isRequiredError;
                }

                let regex = /^[0-9]+(\.[0-9]{2})?$/
                let isMatch = regex.test(selectedPaymentAmount);

                if (!isMatch) {
                    return "Payment amount must be of form XXXX.XX";
                }
                if (selectedPaymentAmount > state.maxPaymentServicesAmount) {
                    return "Payment must be less than $" + state.maxPaymentServicesAmount;
                }

                let paymentMaxAmount = state.makePaymentModel.maxAmountResponse.paymentServicesMaxAmount;
                let billerMaxAmount = state.makePaymentModel.maxAmountResponse.billerRecordMaxAmount;
                let minAmount = state.makePaymentModel.maxAmountResponse.minAmount;

                if (billerMaxAmount <= paymentMaxAmount && selectedPaymentAmount > billerMaxAmount && state.customAmountSelected) {
                    return 'Payment amount is higher than what you owe. Review your entry and try again or contact us for assistance.';
                }
                else if (selectedPaymentAmount > paymentMaxAmount && state.customAmountSelected) {
                    return 'Payment amount is higher than the single-transaction limit. Lower your payment and try again or contact us for assistance.';
                }

                if (selectedPaymentAmount < minAmount) {
                    return "Payment must be $" + minAmount + " or more";
                }
                return null;
            }

            watch(() => state.customPaymentAmount, (newVal, oldVal) => {
                const regex = /^[0-9]*\.?[0-9]*$/;
                if (state.customAmountSelected && !regex.test(newVal)) {
                    state.customPaymentAmount = oldVal;
                }
            });

            const validateAuthenticationForm = () => {
                if (state.authenticationForm.formSubmitted) {
                    state.authenticationForm.accountOrPolicyNumberError = getAccountOrPolicyNumberError();
                    state.authenticationForm.zipCodeError = getZipCodeError();
                }

                return state.authenticationForm.accountOrPolicyNumberError === null && state.authenticationForm.zipCodeError === null;
            }
            const getAccountOrPolicyNumberError = () => getIsRequiredError(state.authenticationModel.accountOrPolicyNumber, "Account or policy number");
            const getZipCodeError = () => getIsRequiredError(state.authenticationModel.zipCode, "Zip code");

            const validatePaymentOptionsForm = () => {
                if (state.paymentOptionsForm.formSubmitted) {
                    state.paymentOptionsForm.emailAddressError = getEmailAddressError(state.emailAddress);
                    state.paymentOptionsForm.confirmEmailAddressError = getConfirmEmailAddressError(state.confirmEmailAddress, state.emailAddress);
                    state.paymentOptionsForm.paymentAmountError = getPaymentAmountError();
                }

                return state.paymentOptionsForm.emailAddressError === null && state.paymentOptionsForm.confirmEmailAddressError === null && state.paymentOptionsForm.paymentAmountError === null;                
            }

            const getEmailAddressError = (email) => {
                const isRequiredError = getIsRequiredError(email, "Email address");
                if (isRequiredError !== null) {
                    return isRequiredError;
                }

                let regex = /^[A-z0-9!#$%&'*+/=?^_`|~.-]+@[A-z0-9]([A-z0-9-]*[A-z0-9])?(.[A-z0-9]([A-z0-9-]*[A-z0-9])?)*$/;
                let isMatch = regex.test(email);

                if (!isMatch) {
                    return "Email addresses formatting is incorrect"
                }
                return null;
            }

            const getConfirmEmailAddressError = (confirmEmail, email) => {
                const isRequiredError = getIsRequiredError(confirmEmail, "Confirm Email address");
                if (isRequiredError !== null) {
                    return isRequiredError;
                }

                if (confirmEmail !== email) {
                    return "Email addresses must match";
                }
                return null;
            }

            const validateReviewScreen = () => {
                if (!state.acceptedLegalAgreement) {
                    return false;
                }
                else {
                    return true;
                }
            }

            watch(() => state.acceptedLegalAgreement, () => {
                if (!state.acceptedLegalAgreement) {
                    state.acceptedLegalAgreementError = "You must accept the terms and conditions to continue";
                }
                else {
                    state.acceptedLegalAgreementError = null;
                }
            });

            const validateRequestAccessForm = () => {
                if (state.connectAccessRequest.formSubmitted) {
                    state.connectAccessRequest.firstNameError = getIsRequiredError(state.connectAccessRequest.firstName, "First name");
                    state.connectAccessRequest.lastNameError = getIsRequiredError(state.connectAccessRequest.lastName, "Last name");
                    state.connectAccessRequest.emailAddressError = getEmailAddressError(state.connectAccessRequest.emailAddress);
                    state.connectAccessRequest.confirmEmailAddressError = getConfirmEmailAddressError(state.connectAccessRequest.confirmEmailAddress, state.connectAccessRequest.emailAddress);
                }

                return state.connectAccessRequest.emailAddressError === null &&
                    state.connectAccessRequest.confirmEmailAddressError === null &&
                    state.connectAccessRequest.firstNameError === null &&
                    state.connectAccessRequest.lastNameError === null;  
            }

            const loader = useLoading();
            let fullPageSpinner = ref(null);
            let fullPageSpinnerInitialized = false;
            let modalSpinner = ref(null);
            let modalSpinnerInitialized = false;

            watchEffect(() => {
                if (fullPageSpinner.value && !fullPageSpinnerInitialized) {
                    fullPageSpinnerInitialized = true;
                    loader.show({
                        container: fullPageSpinner.value
                    });
                }
                if (modalSpinner.value && !modalSpinnerInitialized) {
                    modalSpinnerInitialized = true;
                    loader.show({
                        container: modalSpinner.value
                    })
                }
            });

            const showLoadingImage = () => {
                state.displayLoadingImage = true;
            };
            const hideLoadingImage = () => {
                state.displayLoadingImage = false;
            };
            const showLoadingImageBackdrop = () => {
                state.displayLoadingImageBackdrop = true;
            };
            const hideLoadingImageBackdrop = () => {
                state.displayLoadingImageBackdrop = false;
            };  

            const trackEvent = (event) => {
                const appendedEvent = {
                    ...event,
                    ...(state?.authenticationModel?.businessUnitCode ? { businessUnitCode: state.authenticationModel.businessUnitCode } : {})
                }
                googleAnalytics.trackEvent(appendedEvent)
            }

            watch(() => state.activeSection, (newValue, oldValue) => {
                if (newValue && newValue !== oldValue) {
                    trackEvent({ event: 'VirtualPageView', virtualPageTitle: newValue });
                }
            }, { immediate: true });

            const disablePage = () => {
                showLoadingImage();
                state.disableSubmitButtons = true;
            }

            const enablePage = () => {
                hideLoadingImage();
                state.disableSubmitButtons = false;
            }

            const restart = (category, action) => {
                disablePage();
                window.location.reload();
            };

            const back = () => {
                state.activeSection = state.makePayment;
                resetReviewPage();
                scrollToHash();
            };

            function scrollToHash() {
                const hash = window.location.hash.substring(1); // remove the '#' character
                const element = document.getElementById(hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }

            const previousPaymentModalCancel = () => {
                state.showBillerPayments = false;
                loadingService.hideBackdrop();
            };

            const customAmountSelectedClick = () => {
                state.customAmountSelected = true;
                state.paymentAmountSelected = 'Entered Amount';
            };

            const resetPaymentOptionsClick = () => {
                refreshPaymentOptions();
            };

            const editPaymentData = (label) => {
                state.activeSection = state.makePayment;
                resetReviewPage();
                scrollToHash();
            };

            const printPage = () => {
                window.print();
            };

            const toggleLegalAgreement = () => {
                state.acceptedLegalAgreement = !state.acceptedLegalAgreement;
            };

            const acceptAgreementModal = () => {
                state.acceptedLegalAgreement = true;
            };

            const signUpKeypress = () => {
                state.requestAccessActiveSection = state.confirmationModel.formSection;
            };

            const validateEmailsMatch = (email, conf) => {
                state.paymentOptionsForm.emailsMatch = (email === conf) && !(!email && !conf);
            };

            const validateAccessRequestEmailsMatch = (email, conf) => {
                state.connectAccessRequest.emailsMatch = (email === conf) && !(!email && !conf);
            };

            const enablePageAndScroll = () => {
                hideLoadingImage();
                scrollToHash();
                state.disableSubmitButtons = false;
            };

            const resetSelectBillerPage = () => {
                state.selectedBiller = null;
                state.makePaymentModel = null;
                state.authenticationModel.accountOrPolicyNumber = '';
                state.authenticationModel.zipCode = '';
            };

            const resetMakePaymentPage = () => {
                state.selectedBiller = null;
                state.makePaymentModel.transaction.payLinkSrc = null;
                state.makePaymentModel.transaction.payLinkPasskey = null;
                state.showPaymentServicesiframe = true;
                state.paymentAmountSelected = "";
                state.paymentAmount = 0;
                state.customPaymentAmount = null;
                state.customAmountSelected = false;
                state.paylinkCompleteModel = null;
                state.emailAddress = '';
                state.confirmEmailAddress = '';
            };

            const resetReviewPage = () => {
                state.acceptedLegalAgreement = false;
                state.acceptedLegalAgreementError = null;
            };


            const selectedPaymentAmount = (amount) => {//customPaymentAmount

                //if the amount due is zero or less, force them to use the custom amount field
                if (amount <= 0) {
                    state.customAmountSelected = true;
                    state.paymentAmountSelected = "Entered Amount";
                }
                if (state.customAmountSelected) {
                    state.customPaymentAmount = amount;
                } else {
                    state.paymentAmount = amount;
                }
                return

            };

            const getSelectedPaymentAmount = () => {
                if (state.customAmountSelected) {
                    return state.customPaymentAmount;
                } else {
                    return state.paymentAmount;
                }
            }

            const validateAuthentication = () => {
                if (!state.disableSubmitButtons) {
                    disablePage();
                    state.authenticationForm.formSubmitted = true;
                    const isValid = validateAuthenticationForm();

                    if (isValid) {
                        //submit the form via ajax
                        state.authenticationModel.validationResults = null;

                        fetch(state.authenticationModel.formResponseRoute, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', 'RequestVerificationToken': $('input[name=__RequestVerificationToken]').val() },
                            body: JSON.stringify(state.authenticationModel)
                        }).
                        then(response => {
                            if (!response.ok) throw new Error("Non-200 response");
                            else return response.json();
                        }).
                        then(data => {
                            if (!data.failure) {
                                if (data.redirect) {
                                    $window.location.href = data.redirect;
                                    return;
                                }
                                //switch to the payment context, load in the makePayment model                                                  
                                state.makePaymentModel = data.model;
                                state.authenticationModel.businessUnitCode = data.model.businessUnitCode;
                                state.iframeLoading = true;
                                if (state.makePaymentModel.billers.length === 1) {
                                    state.selectedBiller = state.makePaymentModel.billers[0];
                                    if (state.selectedBiller.customerServicePhoneNumber) {
                                        state.selectedBiller.showCustomerServicePhoneNumber = true;
                                    }
                                    selectedPaymentAmount(state.selectedBiller.preSelectedAmount);
                                    state.paymentAmountSelected = state.selectedBiller.preSelectedLabel;
                                    if (state.selectedBiller.payments.length > 0) {
                                        //show a modal about past history and warn them
                                        $('#showBillerPayments').modal('show');
                                    } else {
                                        state.activeSection = state.makePayment;
                                    }
                                } else {
                                    state.activeSection = state.selectBiller;
                                }
                                enablePageAndScroll();
                            } else {
                                //put the errors into the authentication model
                                if (data.noResult) {
                                    //just a simple error telling the user we could not find the account/policy and zip combination
                                    setModal(data.modal);
                                    setModalDisplay(true);
                                } else if (data.multipleResults) {
                                    //a fancy modal saying that the feature is unavailable, and that they will need to call us
                                    setModal(data.modal);
                                    setModalDisplay(true);
                                } else {
                                    //it must be a validation error, put it on the screen
                                    state.authenticationModel.validationResults = data.errors;
                                }
                                enablePageAndScroll();
                            }
                        }).
                        catch(() => {
                            enablePageAndScroll();
                            genericError();
                        });
                    } else {
                        enablePageAndScroll();
                    }
                }
            }

            const billerSelected = (id) => {
                for (let i = 0; i < state.makePaymentModel.billers.length; i++) {
                    if (state.makePaymentModel.billers[i].billerId === id) {
                        state.selectedBiller = state.makePaymentModel.billers[i];
                        if (state.selectedBiller.customerServicePhoneNumber) {
                            state.selectedBiller.showCustomerServicePhoneNumber = true;
                        }
                        selectedPaymentAmount(state.selectedBiller.preSelectedAmount);
                        state.paymentAmountSelected = state.selectedBiller.preSelectedLabel;
                        break;
                    }
                }

                if (state.selectedBiller.payments.length > 0) {
                    //show a modal about past history and warn them
                    $('#showBillerPayments').modal('show');
                } else {
                    advanceToPaymentOptions();
                }
            }

            const advanceToPaymentOptions = () => {
                if (!state.disableSubmitButtons) {
                    disablePage();

                    state.iframeLoading = true;
                    selectedPaymentAmount(state.selectedBiller.preSelectedAmount);
                    state.paymentAmountSelected = state.selectedBiller.preSelectedLabel;
                    state.activeSection = state.makePayment;

                    enablePage();
                }
            }

            const getPaylinkTransaction = (id) => {
                if (!state.disableSubmitButtons) {
                    disablePage();

                    state.paylinkTransactionRequest = {
                        accountOrPolicyNumber: state.authenticationModel.accountOrPolicyNumber,
                        zipCode: state.authenticationModel.zipCode,
                        billerId: id,
                        __RequestVerificationToken: $('input[name=__RequestVerificationToken]').val()
                    };

                    for (i = 0; i < state.makePaymentModel.billers.length; i++) {
                        if (state.makePaymentModel.billers[i].billerId === id) {
                            state.selectedBiller = state.makePaymentModel.billers[i];
                            selectedPaymentAmount(state.selectedBiller.preSelectedAmount);
                            state.paymentAmountSelected = state.selectedBiller.preSelectedLabel;
                            break;
                        }
                    }

                    //submit the form via ajax
                    state.authenticationModel.validationResults = null;

                    fetch(state.makePaymentModel.paylinkTransactionRoute, {
                        method: 'POST',
                        body: JSON.stringify(state.paylinkTransactionRequest),
                        headers: { 'Content-Type': 'application/json', 'RequestVerificationToken': $('input[name=__RequestVerificationToken]').val() }
                    })
                    .then(response => {
                        if (!response.ok) throw new Error("Non-200 response");
                        else return response.json();
                    })
                    .then(data => {
                        if (!data.failure) {
                            //switch to the payment context, load in the makePayment model
                            enablePage();
                            state.makePaymentModel.transaction.payLinkSrc = data.model.payLinkSrc;
                            state.makePaymentModel.transaction.payLinkPasskey = data.model.payLinkPasskey;
                            state.makePaymentModel.transaction.acceptsCreditCards = data.model.acceptsCreditCards;
                            state.iframeLoading = true;
                            selectedPaymentAmount(state.selectedBiller.preSelectedAmount);
                            state.paymentAmountSelected = state.selectedBiller.preSelectedLabel;
                            state.activeSection = state.makePayment;
                        } else {
                            if (data.criticalFailure) {
                                //critical failures should not occur unless JS variables are tampered with, I guess we can still be polite.
                                createModal("Error", "An error has occured. Please refresh the page and start again.", "Continue", "");
                                //restart the whole process
                            }
                            enablePage();
                        }
                    })
                    .catch(() => {
                        //some generic error happened, let the user know and who to call (ghostbusters)
                        enablePage();
                        genericError();
                    });
                }
            }

            const paylinkCompletion = () => {
                //call paylink complete and get the guid that we need to identify the payment
                //also, populate a modal to show the details on our site in a read only summarized form, with the reset button available  
                hideLoadingImageBackdrop();
                if (!state.disableSubmitButtons) {
                    disablePage();
                    state.showMakePaymentModal = false;
                    $('#showMakePaymentModal').modal('hide');
                    state.paylinkCompleteRequest = {
                        passKey: state.makePaymentModel.transaction.payLinkPasskey,
                        accountPolicyNumber: state.authenticationModel.accountOrPolicyNumber,
                        zipCode: state.authenticationModel.zipCode,
                        billerId: state.selectedBiller.billerId,
                        __RequestVerificationToken: $('input[name=__RequestVerificationToken]').val()
                    };

                    fetch(state.makePaymentModel.payLinkCompleteRoute, {
                        method: 'POST',
                        body: JSON.stringify(state.paylinkCompleteRequest),
                        headers: { 'Content-Type': 'application/json', 'RequestVerificationToken': $('input[name=__RequestVerificationToken]').val() }
                    }).
                    then((response) => response.json()).
                    then((data) => {
                        if (!data.failure) {
                            state.paylinkCompleteModel = data.model;
                            state.showPaymentServicesiframe = false;
                            //print out some pretty version of the information collected from payments services, with the reset button to kill it all
                        } else {
                            //show a modal telling them an error happened, and wipe out the iframe
                            createModal("Error", "An error has occured. Please enter your financial information again.", "Continue", "");
                            refreshPaymentOptions();
                        }
                        enablePage();
                    }).
                    catch(() => {
                        genericError();
                        refreshPaymentOptions();
                        enablePage();
                    });                   
                }
            }
            quickpayApp.config.globalProperties.paylinkCompletion = paylinkCompletion;

            const paylinkFailure = () => {
                //post an error on the page, and reset the iframe
                hideLoadingImageBackdrop();
                state.showPaymentServicesiframe = false;
                $('#showMakePaymentModal').modal('hide');
                refreshPaymentOptions();
            }
            quickpayApp.config.globalProperties.paylinkFailure = paylinkFailure;

            const paylinkFriendlyDecline = () => {
                // hideadd payment method modal and show the friendly decline modal
                hideLoadingImageBackdrop();
                state.showMakePaymentModal = false;
                $('#showMakePaymentModal').modal('hide');
                $('#modalFriendlyDecline').modal('show');
            }
            quickpayApp.config.globalProperties.paylinkFriendlyDecline = paylinkFriendlyDecline;

            const reloadFromFriendlyDecline = () => {
                // close the friendly decline modal and refresh to reload the add payment method modal
                $('#modalFriendlyDecline').modal('hide');
                refreshPaymentOptions();
            }

            const backFromPaymentInfo = () => {
                if (state.makePaymentModel.billers.length > 1) {
                    state.activeSection = state.selectBiller;
                    resetMakePaymentPage();
                } else {
                    resetMakePaymentPage();
                    resetSelectBillerPage();
                    state.activeSection = state.authentication;
                }
            }

            const backFromPaymentInfoLabel = computed(() => {
                if (state.makePaymentModel && state.makePaymentModel.billers && state.makePaymentModel.billers.length > 1) {
                    return "Select invoice";
                } else {
                    return "Back";
                }
            });

            //the final validation that valid dollar amounts etc are selected, and that the paylink complete object exists and is correctly populated
            const validatePaymentOptions = () => {

                if (!state.disableSubmitButtons) {
                    disablePage();

                    state.paymentOptionsForm.formSubmitted = true;
                    const isValid = validatePaymentOptionsForm();

                    if (isValid) {

                        if (!state.paylinkCompleteModel) {
                            //put an error on the screen requesting completion of the financial source
                            enablePageAndScroll();
                            createModal("Error", "Please add a payment method.", "Continue", "");
                            return;
                        }

                        const selectedPaymentAmount = parseFloat(getSelectedPaymentAmount()).toFixed(2);
                        let paymentMaxAmount = state.makePaymentModel.maxAmountResponse.paymentServicesMaxAmount;
                        let billerMaxAmount = state.makePaymentModel.maxAmountResponse.billerRecordMaxAmount;
                        if (billerMaxAmount <= paymentMaxAmount && selectedPaymentAmount > billerMaxAmount && !state.customAmountSelected) {
                            enablePageAndScroll();
                            createModal("Error", "Payment amount is higher than what you owe. Review your entry and try again or contact us for assistance.", "Continue", "");
                            return;
                        }
                        else if (selectedPaymentAmount > paymentMaxAmount && !state.customAmountSelected) {
                            enablePageAndScroll();
                            createModal("Error", "Payment amount is higher than the single-transaction limit. Lower your payment and try again or contact us for assistance.", "Continue", "");
                            return;
                        }

                        state.quickPayValidatePaymentOptions = {
                            __RequestVerificationToken: $('input[name=__RequestVerificationToken]').val(),
                            identifier: state.paylinkCompleteModel.identifier,
                            accountPolicyNumber: state.authenticationModel.accountOrPolicyNumber,
                            zipCode: state.authenticationModel.zipCode,
                            billerId: state.selectedBiller.billerId,
                            paymentAmount: getSelectedPaymentAmount(),
                            emailAddress: state.paymentOptionsForm.emailAddress
                        }
                        //submit the form via ajax
                        state.makePaymentModel.validationResults = null;

                        fetch(state.makePaymentModel.validateOptionsRoute, {
                            method: 'POST',
                            body: JSON.stringify(state.quickPayValidatePaymentOptions),
                            headers: { 'Content-Type': 'application/json', 'RequestVerificationToken': $('input[name=__RequestVerificationToken]').val() }
                        })
                        .then(response => {
                            if (!response.ok) throw new Error("Non-200 response");
                            else return response.json();
                        })
                        .then(data => {
                            if (!data.failure) {
                                //switch to the payment context, load in the makePayment model
                                enablePageAndScroll();
                                state.activeSection = state.review;
                                state.reviewModel = data.model;
                            } else {
                                //put the errors into the authentication model
                                if (data.criticalFailure) {
                                    //critical failures should not occur unless JS variables are tampered with, I guess we can still be polite.
                                    createModal("Error", "An error has occured. Please refresh the page and start again.", "Continue", "");
                                    //restart the whole process
                                }
                                state.authenticationModel.validationResults = data.errors;
                                enablePageAndScroll();
                            }
                        })
                        .catch(() => {
                            //some generic error happened, let the user know and who to call (ghostbusters)
                            enablePageAndScroll();
                            genericError();
                        });
                    }
                    else {
                        enablePageAndScroll();
                    }
                }
            }

            const confirmPayment = () => {
                if (!state.disableSubmitButtons) {
                    disablePage();

                    const isValid = validateReviewScreen();
                    if (isValid) {
                        state.quickPayConfirmPaymentRequest = {
                            identifier: state.paylinkCompleteModel.identifier,
                            accountPolicyNumber: state.authenticationModel.accountOrPolicyNumber,
                            zipCode: state.authenticationModel.zipCode,
                            paymentAmount: getSelectedPaymentAmount(),
                            billerId: state.selectedBiller.billerId,
                            paymentDate: state.reviewModel.paymentDate,
                            withdrawalDate: state.reviewModel.withdrawalDate,
                            emailAddress: state.emailAddress
                        }
                        //submit the form via ajax
                        state.makePaymentModel.validationResults = null;

                        const test = JSON.stringify(state.quickPayConfirmPaymentRequest);
                        fetch(state.makePaymentModel.commitPaymentRoute, {
                            method: 'POST',
                            body: test,
                            headers: { 'Content-Type': 'application/json', 'RequestVerificationToken': $('input[name=__RequestVerificationToken]').val() }
                        })
                        .then(response => {
                            if (!response.ok) throw new Error("Non-200 response");
                            else return response.json();
                        })
                        .then(data => {
                            if (!data.failure) {
                                //switch to the payment context, load in the makePayment model
                                enablePageAndScroll();
                                state.activeSection = state.complete;
                                state.confirmationModel = data.model;
                                state.requestAccessActiveSection = state.confirmationModel.infoSection;
                            } else {
                                //put the errors into the authentication model
                                createModal("Error", "An error has occured and the payment could not be submitted. Please verify the Payment amount and Payment method and try again.", "Continue", "");
                                enablePageAndScroll();
                            }
                        })
                        .catch(() => {
                            //some generic error happened, let the user know and who to call (ghostbusters)
                            enablePageAndScroll();
                            genericError();
                        });
                    }
                    else {
                        enablePageAndScroll();
                    }
                }
            }

            const requestAccess = () => {
                if (!state.disableSubmitButtons) {
                    disablePage();

                    state.connectAccessRequest.formSubmitted = true;
                    const isValid = validateRequestAccessForm();

                    if (isValid) {
                        trackEvent({ event: "CustomerSelfServiceAccessRequested" });

                        state.connectAccessRequest.validationResults = null;
                        state.connectAccessRequest.__RequestVerificationToken = $('input[name=__RequestVerificationToken]').val();
                        state.connectAccessRequest.accountNumber = state.selectedBiller.primaryAccountId;
                        state.connectAccessRequest.accountName = state.selectedBiller.accountName;

                        fetch(state.confirmationModel.connectAccessRequestRoute, {
                            method: 'POST',
                            body: JSON.stringify(state.connectAccessRequest),
                            headers: { 'Content-Type': 'application/json', 'RequestVerificationToken': $('input[name=__RequestVerificationToken]').val() }
                        })
                        .then(response => {
                            if (!response.ok) throw new Error("Non-200 response");
                            else return response.json();
                        })
                        .then(data => {
                            if (!data.failure) {
                                state.requestAccessActiveSection = state.confirmationModel.successSection;
                            } else {
                                state.connectAccessRequest = data.model;
                            }
                            enablePage();
                        })
                        .catch(() => {
                            //some generic error happened, let the user know and who to call (ghostbusters)
                            enablePage();
                            genericError();
                        });
                    }
                    else {
                        enablePage();
                    }
                }
            }

            const setPayment = (amount, label) => {
                if (!state.disableSubmitButtons) {
                    disablePage();
                    if (state.paymentOptionsForm?.paymentAmount !== undefined) {
                    //    state.paymentOptionsForm.paymentAmount.isValid = true;
                    }
                    state.customAmountSelected = false;
                    selectedPaymentAmount(amount);
                    state.paymentAmountSelected = label;
                    validatePaymentOptionsForm();
                    enablePage();
                }
            }

            const closeAddPaymentMethod = () => {
                if (!state.disableSubmitButtons) {
                    $('#showMakePaymentModal').modal('hide');
                }
            }

            const refreshPaymentOptions = () => {
                if (!state.disableSubmitButtons) {
                    state.iframeLoading = true;
                    $('#modalFriendlyDecline').modal('hide');
                    $('#showMakePaymentModal').modal('show');
                    disablePage();

                    state.paylinkRestartRequest = {
                        accountPolicyNumber: state.authenticationModel.accountOrPolicyNumber,
                        zipCode: state.authenticationModel.zipCode,
                        billerId: state.selectedBiller.billerId,
                        __RequestVerificationToken: $('input[name=__RequestVerificationToken]').val()
                    };

                    fetch(state.makePaymentModel.payLinkRestartRoute, {
                        method: 'POST',
                        body: JSON.stringify(state.paylinkRestartRequest),
                        headers: { 'Content-Type': 'application/json', 'RequestVerificationToken': $('input[name=__RequestVerificationToken]').val() }
                    })
                    .then(response => {
                        if (!response.ok) throw new Error("Non-200 response");
                        else return response.json();
                    })
                    .then(data => {
                        if (!data.failure) {
                            state.makePaymentModel.transaction.payLinkSrc = data.model.payLinkSrc;
                            state.makePaymentModel.transaction.payLinkPasskey = data.model.payLinkPasskey;
                            state.makePaymentModel.transaction.acceptsCreditCards = data.model.acceptsCreditCards;
                            state.showPaymentServicesiframe = true;
                            state.paylinkCompleteModel = null;
                        } else {
                            //this is really bad, so bad, we need to restart
                            createModal("Error", "An error has occured. Please refresh the page and start again.", "Continue", "");
                        }
                        enablePage();
                    })
                    .catch(() => {
                        //this is really bad, so bad, we need to restart
                        createModal("Error", "An error has occured. Please refresh the page and start again.", "Continue", "");
                        enablePage();
                    });
                }
            }

            const accountOrPolicyModal = () => {
                state.accountOrPolicyHelp = true;
                showLoadingImageBackdrop();
            }

            const invoiceModal = () => {
                state.invoiceHelp = true;
                showLoadingImageBackdrop();
            }

            const iframeLoaded = () => {
                state.iframeLoading = false;
            }
            quickpayApp.config.globalProperties.iframeLoaded = iframeLoaded;

            const setModalDisplay = (shouldDisplay) => {

                if (!shouldDisplay) {
                    $('#genericModal').modal('hide');
                } else {
                    $('#genericModal').modal('show');
                }
            };

            const setModal = (newModal) => {
                state.modal.title = newModal.title;
                state.modal.message = newModal.message;
                state.modal.confirmText = newModal.confirmText;
                state.modal.classes = newModal.classes;
            };

            const callModalConfirmationScript = () => {
                setModalDisplay(false);
            };

            const callModalCancelScript = () => {
                setModalDisplay(false);
            };

            const genericError = () => {
                state.modal.title = "Error";
                state.modal.message = "An error has occured. Please try again, or call " + state.supportNumber + " for assitance.";
                state.modal.confirmText = "Continue";
                state.modal.classes = "";
                setModalDisplay(true);
            };

            const createModal = (title, message, confirmText, classes) => {
                state.modal.title = title;
                state.modal.message = message;
                state.confirmText = confirmText;
                if (!!classes) {
                    state.modal.classes = classes;
                }
                setModalDisplay(true);
            };

            const currencyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

            // Expose the state and methods to the template
            return {
                state,
                currencyFormatter,
                fullPageSpinner,
                modalSpinner,
                createModal,
                genericError,
                iframeLoaded,
                callModalCancelScript,
                callModalConfirmationScript,
                setModal,
                setModalDisplay,
                invoiceModal,
                accountOrPolicyModal,
                refreshPaymentOptions,
                closeAddPaymentMethod,
                setPayment,
                requestAccess,
                confirmPayment,
                validatePaymentOptions,
                backFromPaymentInfoLabel,
                backFromPaymentInfo,
                reloadFromFriendlyDecline,
                paylinkFriendlyDecline,
                paylinkFailure,
                paylinkCompletion,
                getPaylinkTransaction,
                advanceToPaymentOptions,
                billerSelected,
                validateAuthentication,
                getSelectedPaymentAmount,
                selectedPaymentAmount,
                resetReviewPage,
                resetMakePaymentPage,
                resetSelectBillerPage,
                enablePageAndScroll,
                validateAccessRequestEmailsMatch,
                validateEmailsMatch,
                signUpKeypress,
                acceptAgreementModal,
                toggleLegalAgreement,
                printPage,
                editPaymentData,
                resetPaymentOptionsClick,
                customAmountSelectedClick,
                previousPaymentModalCancel,
                back,
                restart,
                enablePage,
                disablePage,
                hideLoadingImageBackdrop,
                showLoadingImageBackdrop,
                hideLoadingImage,
                showLoadingImage,
                getEmailAddressError,
                validateAuthenticationForm,
                validatePaymentOptionsForm,
                validateReviewScreen,
                validateRequestAccessForm
            };
        }
    };

    const quickpayApp = createApp(app);

    window.quickpayApp = quickpayApp;

    //Suppress this warning as it is intended behavior (runtime compilation of Vue template will ignore the init script)
    quickpayApp.config.warnHandler = function (msg, vm, trace) {
        // `trace` is the component hierarchy trace
        if (msg.includes('Template compilation error: Tags with side effect')) {
            return;
        }
        console.warn(`[Vue warn]: ${msg}${trace}`);
    };
    
    quickpayApp.mount('#quickpay-app');
}